module.exports = __webpack_public_path__ + "static/media/washington-dc.ed5d4766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/washington-dc.jpg
// module id = 537
// module chunks = 0